var exports = {
  "z": "messageMeta__7DKyUm",
  "L": "messageText__zLno1c",
};

module.exports = exports;
